// Module-level fetch + cache of the available coins list. One fetch per
// session shared by every coin picker — the list rarely changes.
// Mirrors the endpoint used by HeaderSearch so widgets get the same coin
// universe the global search surfaces.

import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../utils/apiConfig';

let cache = null;
let pending = null;

async function load() {
  if (cache) return cache;
  if (pending) return pending;
  pending = (async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/available-coins`);
      if (!res.ok) throw new Error('failed');
      const data = await res.json();
      cache = Array.isArray(data?.coins) ? data.coins : [];
      return cache;
    } catch {
      cache = [];
      return cache;
    } finally {
      pending = null;
    }
  })();
  return pending;
}

export function useAvailableCoins() {
  const [coins, setCoins] = useState(() => cache || []);
  useEffect(() => {
    let alive = true;
    if (!cache) {
      load().then((c) => { if (alive) setCoins(c); });
    } else {
      setCoins(cache);
    }
    return () => { alive = false; };
  }, []);
  return coins;
}
